import { Flex, HStack, Spacer, Icon, Text } from '@chakra-ui/react';
import { IoTimeOutline } from 'react-icons/io5';

type StoreStatusBarProps = {
  scheduleTimeString: string;
  onNavigate?: () => void;
};

export default function StoreStatusBar({ scheduleTimeString, onNavigate }: StoreStatusBarProps) {
  return (
    <Flex align="center">
      <HStack>
        <Icon
          as={IoTimeOutline}
          color={['公休', '未營業'].includes(scheduleTimeString) ? 'red.500' : 'fontColor'}
          boxSize="1.25rem"
        />
        <Text fontSize="sm">{scheduleTimeString}</Text>
      </HStack>

      <Spacer />

      <Text
        as="a"
        cursor="pointer"
        fontSize="xs"
        fontWeight="bold"
        color="gray.500"
        onClick={onNavigate}
      >
        查看更多
      </Text>
    </Flex>
  );
}
